import { Clock, MapPin, Phone, Mail, Calendar } from 'lucide-react'

const contactInfo = [
  {
    icon: MapPin,
    title: 'Adress',
    content: 'Säbygatan 15',
    subContent: '261 33 Landskrona',
  },
  {
    icon: Phone,
    title: 'Telefon',
    content: '076-653 46 12',
    subContent: 'Ring för snabb fråga',
  },
  {
    icon: Mail,
    title: 'E-post',
    content: 'info@vk-studio.se',
    subContent: 'Vi svarar inom 24h',
  },
  {
    icon: Clock,
    title: 'Öppettider',
    content: 'Mån-Fre: 10:00 - 19:00',
    subContent: 'Lör: 10:00 - 16:00',
  },
]

export default function Contact() {
  return (
    <section id="kontakt" className="relative py-24 lg:py-32 bg-dark-800 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 right-0 w-1/2 h-1/2 bg-gradient-to-tl from-gold-500/10 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Contact Info */}
          <div>
            <span className="inline-block text-gold-400 font-semibold text-sm tracking-wider uppercase mb-4">
              Kontakt
            </span>
            <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-6">
              Låt oss <span className="text-gradient">prata hår</span>
            </h2>
            <p className="text-gray-300 leading-relaxed mb-8">
              Har du frågor om våra tjänster, priser eller vill boka en tid? 
              Tveka inte att kontakta oss. Det enklaste sättet att boka är via 
              Boka Direkt, men du kan även nå oss på telefon eller mejl.
            </p>

            {/* Info Cards */}
            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {contactInfo.map((info) => (
                <div key={info.title} className="p-5 rounded-xl bg-dark-700/50 hover:bg-dark-700 transition-colors">
                  <div className="w-10 h-10 rounded-lg bg-gold-500/10 flex items-center justify-center mb-3">
                    <info.icon className="w-5 h-5 text-gold-400" />
                  </div>
                  <h4 className="font-semibold text-white mb-1">{info.title}</h4>
                  <p className="text-gray-300 text-sm">{info.content}</p>
                  <p className="text-gray-500 text-xs mt-1">{info.subContent}</p>
                </div>
              ))}
            </div>

            {/* CTA Card */}
            <div className="p-8 rounded-2xl bg-gradient-to-br from-gold-500/20 to-gold-600/20 border border-gold-500/30">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-gold-500 flex items-center justify-center flex-shrink-0">
                  <Calendar className="w-7 h-7 text-dark-900" />
                </div>
                <div>
                  <h3 className="font-display text-2xl font-semibold text-white mb-2">
                    Boka online – snabbt & enkelt
                  </h3>
                  <p className="text-gray-300 mb-4">
                    Via Boka Direkt kan du se våra tillgängliga tider och boka 
                    direkt dygnet runt. Bekräftelse skickas direkt till din mejl.
                  </p>
                  <a
                    href="https://www.bokadirekt.se/places/vk-studio-54503"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-gold-500 text-dark-900 font-semibold rounded-full hover:bg-gold-400 transition-colors"
                  >
                    Gå till Boka Direkt
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map or Image Placeholder */}
          <div className="relative">
            <div className="aspect-[4/5] lg:aspect-auto lg:h-full min-h-[500px] rounded-2xl overflow-hidden bg-dark-700">
              <img
                src="https://images.unsplash.com/photo-1633685444273-4c9bfae801e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="VK Studio location"
                className="w-full h-full object-cover opacity-60"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center p-8">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gold-500 flex items-center justify-center">
                    <MapPin className="w-10 h-10 text-dark-900" />
                  </div>
                  <h3 className="font-display text-2xl font-semibold text-white mb-2">
                    Säbygatan 15, Landskrona
                  </h3>
                  <p className="text-gray-300">
                    261 33 Landskrona
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
